import { Skeleton } from '@nextui-org/react';

const SkeletonLockBox = () => {
  return <Skeleton className="h-[490px] w-full rounded-[18px] bg-gray-50" />;
};

export default SkeletonLockBox;
